import * as React from 'react';
import { RenderHtml as RenderHtmlLibby } from '@wix/answers-ui-libby';
import { isFeatureEnabled } from '@wix/answers-experiments';
import { addLazyLoadingToImages } from './image';
export const RenderHtml = (props) => {
    const maybeDisableSanitation = !isFeatureEnabled('UseLibbyRenderHtmlInArticleViewer') || props.dangerouslyDisableSanitation ? 'i-know-what-i-am-doing' : undefined;
    return (React.createElement(RenderHtmlLibby, { html: addLazyLoadingToImages(props.html), className: props.className, allowedCustomTags: ['iframe', 'video', 'source'], allowedCustomAttributes: ['style'], useDiv: props.useDiv, dangerouslyDisableSanitation: maybeDisableSanitation }));
};
